// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__od8ti"};